import React from 'react';
import { PORTAL_STANDARD_MODAL_PRIORITY } from '@rsos/capstone/src/constants/portalPriorities';
import { Box, Button, Modal, Text } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import ThemeProvider from '@rsos/theme';

const CallOutToTabConfirmationModal = ({ isOpened, onClose, onConfirm }) => {
  const themeName = useSelectedTheme();

  return (
    <ThemeProvider themeName={themeName}>
      <Modal
        id="911inform-click-out-to-tab-confirmation-modal"
        isOpened={isOpened}
        onClose={onClose}
        portalPriority={PORTAL_STANDARD_MODAL_PRIORITY}
        width={440}
      >
        <ModalHeader onClose={onClose}>
          <Text size="xlarge" color="primaryText">
            This will notify multiple contacts at this building. Are you sure
            you want to proceed?
          </Text>
        </ModalHeader>
        <ModalBody>
          <Text size="small" color="primaryText">
            Accessing the connected building will launch 911inform and notify
            contacts (e.g. on-site security, adminstrators, etc...) of this
            potential emergency.
          </Text>
        </ModalBody>
        <ModalFooter justify="space-between" flow={12}>
          <Box grow>
            <Button btnType="secondary" onClick={onClose} noMargin>
              Cancel
            </Button>
          </Box>
          <Box grow>
            <Button btnType="primary" onClick={onConfirm} noMargin>
              Yes, Proceed
            </Button>
          </Box>
        </ModalFooter>
      </Modal>
    </ThemeProvider>
  );
};

export default CallOutToTabConfirmationModal;
